import React, { Component } from "react";
import { connect } from "@common/components/base.component";
import ModalSocio from "../components/socio.modal";
import { Row, Col } from "react-bootstrap";
import Button from "@material-ui/core/Button";
import socioActions from "../store/socio.actions";
import socioSelector from "../store/socio.selectors";
import StaticGridSocio from "../components/socio.staticGrid";
import autoBind from "react-autobind";
import Panel from "@common/externos/components/panel/panel.component";
import decaSelector from "@/modules/deca/store/deca.selectors";
import solicitacaoSelector from "@/modules/deca/components/solicitacao/store/solicitacao.selectors";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  openModalSocio(value) {
    const { socioActions } = this.props;
    socioActions.setPrefix("I");
    socioActions.setStateSocio({});
    socioActions.openModalSocio();
  }

  render() {
    const {
      socioSelector,
      decaSelector,
      form,
      isView,
      disableAll,
    } = this.props;
    const { socio } = socioSelector;
    const { solicitacao } = this.props.solicitacaoSelector;
    const encerramentoDesabilita =
      solicitacao.CCM != undefined && solicitacao.TipoSolicitacao == "3";
    const { deca: decaState } = decaSelector;

    if (decaState.typeDeca == 1 && decaState.loadDeca == 1) return <></>;

    return (
      <>
        <ModalSocio
          form={form}
          show={socio.showHistorico}
          state={socio}
          isView={isView}
        />
        <Panel title={"Sócio"} defaultExpanded={false}>
          <Row className={"mb-4"}>
            <Col>
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.openModalSocio()}
                disabled={!form || disableAll}
              >
                Novo Sócio
                <i className={"fas fa-plus ml-2"} />
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <StaticGridSocio isView={isView} disableAll={disableAll} />
            </Col>
          </Row>
        </Panel>
      </>
    );
  }
}

export default connect({
  actions: {
    socioActions,
  },
  selectors: {
    socioSelector,
    decaSelector,
    solicitacaoSelector,
  },
})(Container);
